<template>
    <div class="camsContainer">
        <div class="nonGraphContainer">
            <div class="pageHeader">
                <ContentHeader :name=this.headerName :subHeader="subHeader" :route="subPage" />
            </div>
        </div>
        <div class="currentView">
            <!-- These selectors should probably be their own component -->
            <div>
                <div class="dataTableSelectorGroup">
                    <div class="dataTableSelector">
                        <SearchBar v-bind:search="search" v-bind:searchCallback="(data) => { this.performSearch(data) }"
                            :searchIcon="true" v-bind:exportDataCallback="() => exportData()"
                            :updateDateRangeCallback="(dateRange) => updateDateRange(dateRange)"
                            :clearFiltersCallback="() => clearFilters()" :filters="searchCategories"
                            :searchCategoryUpdated="(category) => updateFilteredSearch(category, search)"
                            :showSupportButtons="true" :updateFiltersCallback="(filters) => handleFilterUpdate(filters)"
                            :filterConfiguration="filterConfiguration" />
                    </div>
                </div>
                <DataTable v-bind:tableData="tableData" v-bind:search="search" :processInputData="processInputData"
                    v-bind:openModalCallback="(item) => handleModal(item)" :headers="headers" />

                <AnalyticsGraph title="At a Glance" v-bind:configuration="users" />
            </div>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../../ContentHeader.vue";
import * as Constants from "../../../js/constants";
import EventBus from "../../../eventBus";
import DataTable from "../pageComps/DataTable.vue";
import SearchBar from "../pageComps/Search.vue";
import CTSRepository from "../../../js/CTSRepository";
import UnitModal from "../../modals/UnitModal.vue";
import { exportCSVFile } from "../../../js/ExportUtils";

export default {
    name: "UnitsPage",
    props: ["subPage", "organizationData", "userData"],
    components: {
        ContentHeader,
        DataTable,
        SearchBar
    },
    data() {
        return {
            selectedItem: Constants.GATE,
            headerName: Constants.USERS,
            subHeader: "Below is a list of all units for your community!",
            filterStartDate: null,
            filterEndDate: null,
            defaultStartDate: null,
            defaultEndDate: null,
            filters: [],
            usersTableData: [],
            tableData: [],
            mappedData: [],
            search: "",
            users: Constants.USERS,
            cardInfo: Constants.DEFAULT_CARD_INFO,
            headers: [
                { text: "Address", value: "unit_full_address", align: "start", sortable: true, width: 300 },
                { text: "Subdivision", value: "unit_subdivision", filterable: true, width: 175 },
                { text: "Associated Users", value: "unit_associated_user_string", filterable: true, width: 175 },
                { text: "Status", value: "current_status", filterable: true, width: 180 },
                { text: "Unit Type", value: "unit_type", filterable: true, width: 180 },
                { text: "Move In Date", value: "unit_move_in_date_formatted", filterable: false, width: 180 },
                { text: "Renewal Date", value: "unit_renewal_date_formatted", filterable: false, width: 180 },
                { text: "Pet?", value: "pet", filterable: false, width: 180 },
                { text: "Unit ID", value: "unit_id", filterable: false, width: 180 },
            ],
            searchFilters: {},
            filterConfiguration: [
                {
                    sectionLabel: "Unit Information",
                    sectionFields: [
                        {
                            displayLabel: "Unit Address",
                            key: "visitor_first_name",
                            configuration: {
                                type: 'input',
                                placeholder: "Input"
                            }
                        },
                        // {
                        //     displayLabel: "Resident Name",
                        //     key: "unit_tenant",
                        //     configuration: {
                        //         type: 'input',
                        //         placeholder: "Input"
                        //     }
                        // },
                        {
                            displayLabel: "Unit Type",
                            key: "unit_type",
                            configuration: {
                                type: 'select',
                                options: [
                                    { label: "Non Rental", value: "Non Rental" },
                                    { label: "Single Family", value: "Single Family" },
                                    { label: "Rental", value: "Rental" }
                                ],
                                placeholder: "Select"
                            }
                        }
                    ]
                },
                {
                    sectionLabel: "Visitor Entry Time",
                    sectionFields: [
                        {
                            displayLabel: "Sort by",
                            key: "sort_by",
                            configuration: {
                                type: 'select',
                                options: [
                                    { label: "Newest to Oldest", value: "desc" },
                                    { label: "Oldest to Newest", value: "asc" }
                                ],
                                placeholder: "Select"
                            }
                        }
                    ]
                },
            ],
            selectedSearchCategory: null,
            searchCategories: [
                { value: "unit_type", label: "Type" },
                { value: "unit_full_address", label: "Address" },
                { value: "unit_subdivision", label: "Subdivision" },
                { value: "unit_zip", label: "ZIP Code" },
                { value: "unit_state", label: "State" },
                { value: "current_status", label: "Status" },
                { value: "unit_tenant", label: "Tenant" },
                // { value: "unit_move_in_date", label: "License Plate" },
                // { value: "unit_renewal_date", label: "License Plate" },
                // { value: "reporter", label: "License Plate" }
            ],
        };
    },
    watch: {
        search(newVal) {
            if (newVal == "") {
                this.performSearch(newVal)
            }
        },
        organizationData: function (newVal) {
            this.communityId = newVal.organization_id
            this.performSearch(this.search)
        }
    },
    created() {
        this.changeView(this.selectedItem);
        EventBus.$on("keys", this.changeView);
        EventBus.$on("incidents", this.changeView);

        var date = new Date();
        this.defaultEndDate = date.toISOString().split('T')[0]
        var startDate = new Date(date)
        startDate.setDate(date.getDate() - 7);
        //this.defaultStartDate = startDate.toISOString().split('T')[0]
        this.defaultStartDate = "2019-06-06"


        this.performSearch("").then((apiData) => {
            console.log("Finished getting and setting API Data", apiData);
        });
    },
    methods: {
        openGateFiletersModal() {
            console.log("Opening Gate Filters Modal")
        },
        homeChangeText() {
            console.log("Home knows the button was clicked");
        },
        changeView(name) {
            console.log("Changing View from ", this.selectedItem, " to ", name);
            if (name == "keys") {
                this.showKeys = true;
                this.showIncidents = false;
                this.selectedItem = name;
            } else if (name == "incidents") {
                this.showIncidents = true;
                this.showKeys = false;
                this.selectedItem = name;
            }
        },
        performSearch(data) {
            this.search = data
            this.updateFilteredSearch(this.selectedSearchCategory, data)
            // if (data == "" || data == undefined) {
            //     new CTSRepository(this.$props.organizationData).fetchAllUnits().then((data) => {
            //         console.log("Search Data", data);
            //         this.tableData = data
            //     }).catch((err) => {
            //         console.log("Error fetching Units", err)
            //     });
            // } else {
            new CTSRepository(this.$props.organizationData).searchUnits(this.search, this.searchFilters).then((data) => {
                console.log("Search Data", data);
                this.tableData = data
            }).catch((err) => {
                console.log("Error fetching Units", err)
            });
            //}

        },
        handleModal(item) {
            this.$modal.show(UnitModal, {
                unitData: item,
                organizationData: this.$props.organizationData,
                userData: this.$props.userData,
            }, {
                transition: "fade",
                top: "0",
                width: "650",
                height: "auto",
                draggable: "true",
                adaptive: false,
                styles: "border-radius: 22px;"
            })
        },
        exportData() {
            const headers = this.headers
                .map(h => h.text) // column labels
                .join(',')

            const rows = this.mappedData.map(item =>
                this.headers
                    .map(h => {
                        const value = item[h.value]
                        return `"${(value ?? '').toString().replace(/"/g, '""')}"`
                    })
                    .join(',')
            )
            exportCSVFile(headers, rows, `${this.$props.organizationData.organization_name} Units.csv`)
        },
        processInputData(inputData) {
            let mappedData = inputData.map(item => {
                let associatedUserString = ""
                if (item.associated_users.length > 1) {
                    associatedUserString = `${item.associated_users.length} Associated Users`
                } else if (item.associated_users.length == 1 && item.associated_users[0] != null) {
                    let associatedUser = item.associated_users[0]
                    associatedUserString = `${associatedUser.user_first_name} ${associatedUser.user_last_name}`
                }
                return {
                    ...item,
                    pet: "No",
                    unit_move_in_date_formatted: item.unit_move_in_date ? new Date(item.unit_move_in_date).toLocaleDateString() : "",
                    unit_renewal_date_formatted: item.unit_renewal_date ? new Date(item.unit_renewal_date).toLocaleDateString() : "",
                    unit_associated_user_string: associatedUserString,
                }
            })
            this.mappedData = mappedData
            return mappedData
        },
        updateFilteredSearch(category, data) {
            console.log(`Updating Filtered Search ${category}, ${data}`)
            if (category == null || category.trim() == "") {
                delete this.searchFilters[this.selectedSearchCategory]
                return;
            }
            //if (data == null || data == undefined || data.trim() == "") {
            delete this.searchFilters[this.selectedSearchCategory]
            delete this.searchFilters[category]
            //    return;
            //}
            console.log(`Updating Filtered Search ${category}, ${data}`)
            this.selectedSearchCategory = category
            this.searchFilters[category] = data
        },
        updateDateRange(dateRange) {
            this.searchFilters['start_time'] = dateRange[0]
            this.searchFilters['end_time'] = dateRange[1]
        },
        clearFilters() {
            this.searchFilters = {}
            this.selectedSearchCategory = ""
            this.performSearch("")
        },
        handleFilterUpdate(filters) {
            Object.assign(this.searchFilters, filters)
            this.performSearch(this.search)
        }
    },
};
</script>

<style scoped>
.dataTableSelectorGroup {
    display: flex;
    widows: 100%;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 16px;
}

.dataTableSelector:nth-child(3n) {
    margin-right: 0px;
}

.selectorContent {
    width: 100%;
    color: white;
    font-size: 28px;
    display: inline;
    margin-right: 16px;
}

.selectorContent::placeholder {
    width: 100%;
    color: white;
    font-size: 28px;
}

.pageHeader button {
    background-color: #1890FFCC;
    color: white;
}

.filterIcon {
    margin-right: 16px;
    display: inline;

}

.iconGroup {
    display: inline;
}
</style>